import React, { useEffect, useState } from "react";
import {
  Drawer,
  Tooltip,
  Select,
  Checkbox,
  Divider,
  Modal,
  DatePicker,
  Spin,
} from "antd";
import {
  CloseIcon,
  DateIcon,
  DeleteIcon,
  IconInformationTemplateReport,
} from "../../../../asset";
import CustomDivider from "../../../../component/divider/CustomDivider";
import MSSOrdeFrom from "../../../../component/mss/order-from";
import { useDispatch, useSelector } from "react-redux";
import RangeDatePicker from "../../../../component/range-date-picker/RangeDatePicker";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import SecondaryButton from "../../../../component/button/SecondaryButton";
import { useTranslation } from "react-i18next";
import style from "./drawerReport.module.css";
import MSSDAStatus from "../../../../component/mss/delivery-associate-status";
import MSSTripStatus from "../../../../component/mss/trip-status";
import MSSOrderStatus from "../../../../component/mss/order-status";
import { selectOption } from "../../../../component/select/SelectOption";
import axios from "axios";
import { GROLOG_ORDER_URL } from "../../../../constant/apiConstant";
import MSSTrip from "../../../../component/mss/trip";
import Delete from "../../../../component/modal/ModalDelete";
import MSSDeliveryAssociate from "../../../../component/mss/delivery-associate";
import { setGlobalDA, setGlobalDAStatus, setGlobalDepotName, setGlobalIsGetDetail, setGlobalOrderFrom, setGlobalOrderStatus, setGlobalTrip, setGlobalTripStatus } from "../../../../store/reducer/globalMultipleSearchSelect.reducer";
import ModalSuccessAdd from "../../../../component/modal/ModalSuccessAdd";
import ModalFailedDelete from "../../../../component/modal/ModalFailedDelete";
import MSSDepot from "../../../../component/mss/depot";

const DrawerFilterReport = ({
  onClose,
  open,
  filters,
  setFilters,
  handleApply,
  handleReset,
}) => {
  const { Option } = Select;
  const { t } = useTranslation();
  const { RangePicker } = DatePicker;
  const {
    globalOrderFrom,
    globalDepotName,
    globalDAStatus,
    globalDA,
    globalOrderStatus,
    globalTrip,
    globalTripStatus,
    globalIsGetDetail
  } = useSelector((state) => state.globalMSS);
  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  const dispatch = useDispatch();
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const [visible, setVisible] = useState(false);
  const [listFilter, setListFilter] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [detail, setDetail] = useState();
  const [selectedValue, setSelectedValue] = useState("");
  const [newNameTemplate, setNewNameTemplate] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [failedModalOpen, setFailedModalOpen] = useState(false);
  const [messageFail, setMessageFail] = useState("");
  const [messageSuccess, setMessageSuccess] = useState("");
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const dates = [
    { value: "Today", label: "Today" },
    { value: "This Week", label: "This Week" },
    { value: "This Month", label: "This Month" },
    { value: "Last 3 Month", label: "Last 3 Month" },
    { value: "This Year", label: "This Year" },
    { value: "Custom Date", label: "Custom Date" },
  ];
  const [filtersdate, setFiltersdate] = useState({
    period_date: {
      filter: "Today",
      from_date: "",
      thru_date: "",
    },
  });
  const handleChange = (value, name) => {
    if (name === "period") {
      if (value === "Custom Date") {
        setVisible(true);
      } else {
        let period_date = {
          filter: value,
          from_date: "",
          thru_date: "",
        };
        let filter_selection = {
          ...filters?.filter_selection,
          period_date,
        };
        setFilters((prevsValue) => {
          return {
            ...prevsValue,
            filter_selection,
          };
        });
      }
    }
  };

  const doGets = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = GROLOG_ORDER_URL + endpoint;
    const method = "GET";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = GROLOG_ORDER_URL + endpoint;
    const method = "GET";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const doPost = async (endpoint, tkn, data, dispatch, refresh_token) => {
    // const api = `http://app.sbp:9038/v1/grolog`;
    const api = GROLOG_ORDER_URL;
    const url = api + endpoint;
    const method = "POST";
    const headers = {
      Authorization: token,
    };
    const request = { url, method, headers, data };
    return axios(request);
  };

  const doPut = async (endpoint, tkn, data, dispatch, refresh_token) => {
    const url = GROLOG_ORDER_URL + endpoint;
    const method = "PUT";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, data };
    return axios(request);
  };

  useEffect(() => {
    getListFilter(1, 10);
  }, []);

  const getListFilter = async (page, limit, filter) => {
    setFetching(true);
    const currentFilter = [...listFilter];
    let init = await doGets(
      `/filter/initiate?filter=report_type eq Depot Report`,
      token
    );
    let res = await doGets(
      `/filter?page=${page}&limit=${limit}&filter=report_type eq Depot Report${
        filter ? ", name lk " + filter : ""
      }`,
      token
    );
    let list = [];
    let list2 = filter?[
      {
        value: filter,
        label: `${filter}`,
      }
    ] : []
    res?.data?.payload?.data?.map((el) => {
      list?.push({
        value: el?.id,
        label: el?.template_name,
      });
    });
    setListFilter(list?.length > 0 ? list : list2);
    setFetching(false);
  };

  const getDetailFilter = async (id) => {
    let res = await doGet(`/filter/${id}`, token);
    setDetail(res?.data?.payload?.data);
    // setFilters((prevsValue)=>{
    //   return{
    //     ...prevsValue,
    let filter_selection = res?.data?.payload?.data?.filter_selection;
    let column_selection = res?.data?.payload?.data?.column_selection;
    //   };})
    console.log("fs", filter_selection);
    setFilters((prevsValue) => {
      return {
        ...prevsValue,
        ["column_selection"]: column_selection,
        ["filter_selection"]: filter_selection,
      };
    });
    dispatch(setGlobalIsGetDetail(true))
    dispatch(setGlobalDA(filter_selection?.delivery_associate?.list_id));
    dispatch(setGlobalTrip(filter_selection?.trip?.list_id));
    dispatch(setGlobalDepotName(filter_selection?.depot?.list_id));
    dispatch(setGlobalDAStatus(filter_selection?.delivery_associate_status?.list));
    dispatch(setGlobalTripStatus(filter_selection?.trip_status?.list));
    dispatch(setGlobalOrderFrom(filter_selection?.order_from?.list));
    dispatch(setGlobalOrderStatus(filter_selection?.order_status?.list));
    // console.log("tes", ...filters,res?.data?.payload?.data?.filter_selection,res?.data?.payload?.data?.column_selection);
    
  };

  
  useEffect(() => {
    let filter_selection = {
      ...filters?.filter_selection,
      "depot": {
        "list_id": !Array.isArray(globalDepotName) || globalDepotName.length === 0 || (globalDepotName.length === 1 && globalDepotName[0].id === -1) || !globalDepotName.every(item => item.hasOwnProperty('id')) ?
        globalDepotName : globalDepotName.map(item => item.id),
        "exclude": false
    },
    "delivery_associate_status":{
        "list": !Array.isArray(globalDAStatus) || globalDAStatus.length === 0 || (globalDAStatus.length === 1 && globalDAStatus[0].id === "ALL") || !globalDAStatus.every(item => item.hasOwnProperty('id')) ?
        globalDAStatus : globalDAStatus.map(item => item.id),
        "exclude": false
    },
    "delivery_associate":{
        "list_id": !Array.isArray(globalDA) || globalDA.length === 0 || (globalDA.length === 1 && globalDA[0].id === -1) || !globalDA.every(item => item.hasOwnProperty('id')) ?
        globalDA : globalDA.map(item => item.id),
        "exclude": false
    },
    "trip_status":{
        "list": !Array.isArray(globalTripStatus) || globalTripStatus.length === 0 || (globalTripStatus.length === 1 && globalTripStatus[0].id === "ALL") || !globalTripStatus.every(item => item.hasOwnProperty('id')) ?
        globalTripStatus : globalTripStatus.map(item => item.id),
        "exclude": false
    },
    "trip":{
        "list_id": !Array.isArray(globalTrip) || globalTrip.length === 0 || (globalTrip.length === 1 && globalTrip[0].id === -1) || !globalTrip.every(item => item.hasOwnProperty('id')) ?
        globalTrip : globalTrip.map(item => item.id),
        "exclude": false
    },
    "order_from":{
        "list": !Array.isArray(globalOrderFrom) || globalOrderFrom.length === 0 || (globalOrderFrom.length === 1 && globalOrderFrom[0].id === "ALL") || !globalOrderFrom.every(item => item.hasOwnProperty('id')) ?
        globalOrderFrom : globalOrderFrom.map(item => item.id),
        "exclude": false
    },
    "order_status":{
        "list": !Array.isArray(globalOrderStatus) || globalOrderStatus.length === 0 || (globalOrderStatus.length === 1 && globalOrderStatus[0].id === "ALL") || !globalOrderStatus.every(item => item.hasOwnProperty('id')) ?
        globalOrderStatus : globalOrderStatus.map(item => item.id),
        "exclude": false
    }
    }

    setFilters((prevsValue) => {
      return {
        ...prevsValue,
        ["filter_selection"]: filter_selection,
      };
    });
  }, [ globalOrderFrom,
    globalDepotName,
    globalDAStatus,
    globalDA,
    globalOrderStatus,
    globalTrip,
    globalTripStatus]);

  const handleAddTemplate = async () => {
    let datas = {
      report_type: "Depot Report",
      name: newNameTemplate,
      filter_selection: JSON.stringify(filters?.filter_selection),
      column_selection: JSON.stringify(filters?.column_selection),
    };
    try {
      let res = await doPost(`/filter`, token, datas);
      setSuccessModalOpen(true);
      setMessageSuccess("Success add template")
    } catch (err) {
      setMessageFail(err?.response?.data?.message)
      setFailedModalOpen(true)

    }
  };

  const handleEditTemplate = async () => {
    let datas = {
      report_type: "Depot Report",
      name: detail?.template_name,
      filter_selection: JSON.stringify(filters?.filter_selection),
      column_selection: JSON.stringify(filters?.column_selection),
      updated_at: detail?.updated_at,
    };
    try {
      let res = await doPut(`/filter/${detail?.id}`, token, datas);
      setSuccessModalOpen(true);
      setMessageSuccess("Success edit template")
    } catch (err) {
      setMessageFail(err?.response?.data?.message)
      setFailedModalOpen(true)
    }
  };

  const handleDeleteTemplate = () => {};
  console.log("listfilter", listFilter);
  console.log("detilfilter", detail);
  console.log("filters", filters);
  const onChecked = (e, name) => {
    let column_selection = {
      ...filters?.column_selection,
      [name]: e.target.checked,
    };
    setFilters((prevsValue) => {
      return {
        ...prevsValue,
        column_selection,
      };
    });
  };
console.log("filterss", filters);
  const handleSearch = (e) => {
    console.log("eee", e);
    getListFilter(1, 10, e);
  };

  const handleSelect = (e, val) => {
    console.log("eee sel", e);
    if (!isNaN(e)) {
      getDetailFilter(e);
      setSelectedValue(val);
      setNewNameTemplate("");
    } else {
      setNewNameTemplate(e);
    }
  };

  const handleSaveTemplate = () => {
    if (newNameTemplate) {
      handleAddTemplate();
    } else {
      handleEditTemplate();
    }
  };

  const setModal = async (data, condition) => {
    await getDetailFilter(data?.value)
    await setShowDelete(true);
  };

  const actModal = () =>{
    setSuccessModalOpen(false)
    setMessageSuccess("")
  }
  const actModalFail = () =>{
    setFailedModalOpen(false)
    setMessageFail("")
  }
  console.log("fil", filters);
  return (
    <>
    <Delete
      data={detail?.updated_at}
      id={detail?.id}
      delete={showDelete}
      title={detail?.template_name}
      url={"filter"}
      action={() => setShowDelete(false)}
      refresh={()=>getListFilter(1,10)}
      token={token}
      param={param}
    />
    <ModalSuccessAdd
        show={successModalOpen}
        action={() => actModal()}
        closable={false}
        width={280}
        className={style.deleteModal}
        okText="Ok"
        title="Success"
        description={messageSuccess}
      />
      <ModalFailedDelete
        show={failedModalOpen}
        action={() => actModalFail()}
        closable={false}
        width={414}
        className={style.deleteModal}
        okText="Ok"
        title="Data Cant be added"
        description={messageFail}
      />
      <Drawer
        placement="right"
        closable={false}
        onClose={onClose}
        open={open}
        // title={null}
        // onClose={onClose}
        footer={
          <div className="flex justify-end gap-4 mt-5">
            <button
              onClick={() => handleReset()}
              className="border-[2px] border-red-100 w-[140px] h-[44px] rounded-md font-sans text-red-100 font-semibold text-xl"
            >
              Reset
            </button>
            <button
              onClick={() => handleApply()}
              className="bg-red-100 w-[140px] h-[44px] rounded-md font-sans text-white-100 font-semibold text-xl"
            >
              Apply
            </button>
          </div>
        }
        // open={open}
        // closeIcon={null}
        width={"548px"}
      >
        <div className="flex justify-end">
          <img
            onClick={onClose}
            src={CloseIcon}
            style={{ height: "18px", width: "18px", cursor: "pointer" }}
            alt="icon-close"
          />
        </div>
        <div className="container-content-filter-drawer-report">
          <span className="span-title-drawer-report">Filter Report</span>
          <div className="flex flex-col gap-2 h-[1000px] ">
            <div className="flex gap-2">
              <span className="span-label-filter-template-name">
                Filter Template
              </span>
              <Tooltip
                color="#C4C4C4"
                title={
                  <span className="span-tooltip-title">
                    Type here directly to save a new template name or you can
                    select and replace existing one.
                  </span>
                }
                placement="right"
              >
                <img
                  src={IconInformationTemplateReport}
                  alt="icon-information"
                />
              </Tooltip>
            </div>
            <div className="container-save-template">
              {/* <Select
              placeholder="Select Filter Template"
              style={{ width: "80%" }}
              size="large"
            >
            {listFilter}
              </Select> */}
              <Select
                showSearch
                placeholder="Select Filter Template"
                style={{ width: "80%" }}
                size="large"
                optionFilterProp="children"
                filterOption={false}
                value={newNameTemplate ? newNameTemplate : selectedValue}
                notFoundContent={fetching ? <Spin size="small" /> : null}
                onSearch={(e) => handleSearch(e)}
                // onSelect={(e)=>handleSelect(e)}
              >
                {/* <div className="overflow-auto max-h-[700px] h-60"> */}
                {listFilter?.map((el, index) => (
                  <Option>
                    <div
                      key={index}
                      className={" h-7"}
                      onClick={() => handleSelect(el.value, el.label)}
                    >
                      <div className="w-full flex justify-between px-2">
                        {isNaN(el?.value) ? (
                          <span> Add "{el?.label}"</span>
                        ) : (
                          <>
                            <span className="w-[80%]">{el?.label}</span>
                            <Tooltip title={t("Delete")} color="#CF0000">
                              <button
                                onClick={() => setModal(el)}
                              >
                                <img className="" src={DeleteIcon} />
                              </button>
                            </Tooltip>
                          </>
                        )}
                      </div>
                    </div>
                  </Option>
                ))}
                {/* </div> */}
                {/* {listFilter.map((option)=> (
                  <>
        <Option key={option.value} value={option.value}>
            
        <div className="flex justify-between">
          {option.label}
          
        <img src={DeleteIcon} />
        </div>
        </Option>
        
        </>
      ))} */}
              </Select>
              <button
                onClick={() => handleSaveTemplate()}
                className="btn-save-filter-template"
              >
                Save Filter
              </button>
            </div>
            <CustomDivider name="Filter Data" />
            <div className="field-container">
              <span className="span-label-filter-template-name">Depot</span>
              {/* <Select
              style={{ width: "100%" }}
              size="large"
              placeholder="Select Depot"
            /> */}
              <MSSDepot />
            </div>
            <div className="field-container">
              <span className="span-label-filter-template-name">
                Period Date
              </span>

              <Select
                className="w-[100%]"
                dropdownStyle={{
                  backgroundColor: "white",
                }}
                size="large"
                value={filters?.filter_selection?.period_date?.filter}
                onChange={(value) => handleChange(value, "period")}
                options={dates}
                suffixIcon={<img src={DateIcon} alt="date" />}
              />

              <Modal
                open={visible}
                // width={"350px"}
                width={650}
                // className="h-[400px]"
                onCancel={() => setVisible(false)}
                footer={
                  <div>
                    <div style={{ flexDirection: "row" }}>
                      {/* <ErrorMessage
                   children={
                     save === false &&
                     this.props.t("COMMON:VALID_RANGE_DATE", {
                       len:90,
                     })
                   }
                 /> */}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        margin: "3px",
                      }}
                    >
                      <PrimaryButton styles={" mr-2"} text={t("Save")} />
                      <SecondaryButton
                        action={() => setVisible(false)}
                        text={t("Cancel")}
                      />
                    </div>
                  </div>
                  //        );
                }
              >
                <div className="w-[700px] h-96">
                  <RangePicker
                    className={style.datePicker}
                    defaultOpen={visible}
                    showTime={false}
                  />
                </div>
              </Modal>
            </div>
            <div className="field-container">
              <span className="span-label-filter-template-name">
                Delivery Associate Status
              </span>
              <MSSDAStatus />
            </div>
            <div className="field-container">
              <span className="span-label-filter-template-name">
                Delivery Associate
              </span>
              <MSSDeliveryAssociate/>
            </div>
            <div className="field-container">
              <span className="span-label-filter-template-name">
                Trip Status
              </span>
              <MSSTripStatus />
            </div>
            <div className="field-container">
              <span className="span-label-filter-template-name">Trip</span>
              <MSSTrip />
            </div>
            <div className="field-container">
              <span className="span-label-filter-template-name">
                Order From
              </span>
              {/* <Select
              style={{ width: "100%" }}
              size="large"
              placeholder="Select Order From"
            /> */}
              <MSSOrdeFrom />
            </div>
            <div className="field-container">
              <span className="span-label-filter-template-name">
                Order Status
              </span>
              <MSSOrderStatus />
            </div>
            <CustomDivider
              name={
                <div className="flex gap-2">
                  <span>Customize Optional Columns</span>
                  <Tooltip
                    color="#C4C4C4"
                    title={
                      <span className="span-tooltip-title">
                        Customize your table with optional columns. All primary
                        columns has been added as default.
                      </span>
                    }
                    placement="top"
                  >
                    <img
                      src={IconInformationTemplateReport}
                      alt="icon-information"
                    />
                  </Tooltip>
                </div>
              }
            />
            <div className={style.selectOptionContainer}>
              <Checkbox
                onChange={(e) => onChecked(e, "country")}
                checked={filters?.column_selection?.country}
              >
                Country
              </Checkbox>
              <Divider />
              <Checkbox
                onChange={(e) => onChecked(e, "province")}
                checked={filters?.column_selection?.province}
              >
                Province
              </Checkbox>
              <Divider />
              <Checkbox
                onChange={(e) => onChecked(e, "district")}
                checked={filters?.column_selection?.district}
              >
                District
              </Checkbox>
              <Divider />
              <Checkbox
                onChange={(e) => onChecked(e, "sub_district")}
                checked={filters?.column_selection?.sub_district}
              >
                Sub District
              </Checkbox>
              <Divider />
              <Checkbox
                onChange={(e) => onChecked(e, "urban_village")}
                checked={filters?.column_selection?.urban_village}
              >
                Urban Village
              </Checkbox>
              <Divider />
              <Checkbox
                onChange={(e) => onChecked(e, "postal_code")}
                checked={filters?.column_selection?.postal_code}
              >
                Postal Code
              </Checkbox>
              <Divider />
            </div>
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default DrawerFilterReport;
